/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GeocodageAdresseResponseDto } from '../models/geocodage-adresse-response-dto';
import { geocodeAdresseIntervention } from '../fn/geocodage-controller/geocode-adresse-intervention';
import { GeocodeAdresseIntervention$Params } from '../fn/geocodage-controller/geocode-adresse-intervention';
import { getLocalisationById } from '../fn/localisation-controller/get-localisation-by-id';
import { GetLocalisationById$Params } from '../fn/localisation-controller/get-localisation-by-id';
import { getLocalisationsBySite } from '../fn/localisation-controller/get-localisations-by-site';
import { GetLocalisationsBySite$Params } from '../fn/localisation-controller/get-localisations-by-site';
import { LocalisationDto } from '../models/localisation-dto';
import { LocalisationDtoEnrichi } from '../models/localisation-dto-enrichi';
import { patchLocalisation } from '../fn/localisation-controller/patch-localisation';
import { PatchLocalisation$Params } from '../fn/localisation-controller/patch-localisation';

/**
 * Récupérer les infos de localisations
 */
@Injectable({ providedIn: 'root' })
export class LocalisationControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patchLocalisation()` */
  static readonly PatchLocalisationPath = '/v1/localisations/{idLoc}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchLocalisation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchLocalisation$Response(
    params: PatchLocalisation$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<{}>> {
    return patchLocalisation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchLocalisation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchLocalisation(params: PatchLocalisation$Params, context?: HttpContext): Observable<{}> {
    return this.patchLocalisation$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `geocodeAdresseIntervention()` */
  static readonly GeocodeAdresseInterventionPath = '/v1/localisations/{idLocalisation}/geocode-adresse-intervention';

  /**
   * patch.
   *
   * geocoder l'adresse d'intervention de la localisation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geocodeAdresseIntervention()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  geocodeAdresseIntervention$Response(
    params: GeocodeAdresseIntervention$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<GeocodageAdresseResponseDto>> {
    return geocodeAdresseIntervention(this.http, this.rootUrl, params, context);
  }

  /**
   * patch.
   *
   * geocoder l'adresse d'intervention de la localisation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `geocodeAdresseIntervention$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  geocodeAdresseIntervention(
    params: GeocodeAdresseIntervention$Params,
    context?: HttpContext
  ): Observable<GeocodageAdresseResponseDto> {
    return this.geocodeAdresseIntervention$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeocodageAdresseResponseDto>): GeocodageAdresseResponseDto => r.body)
    );
  }

  /** Path part for operation `getLocalisationsBySite()` */
  static readonly GetLocalisationsBySitePath = '/v1/localisations';

  /**
   * get.
   *
   * récupérer les données d'une localisation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLocalisationsBySite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocalisationsBySite$Response(
    params: GetLocalisationsBySite$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<LocalisationDto>>> {
    return getLocalisationsBySite(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * récupérer les données d'une localisation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLocalisationsBySite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocalisationsBySite(
    params: GetLocalisationsBySite$Params,
    context?: HttpContext
  ): Observable<Array<LocalisationDto>> {
    return this.getLocalisationsBySite$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LocalisationDto>>): Array<LocalisationDto> => r.body)
    );
  }

  /** Path part for operation `getLocalisationById()` */
  static readonly GetLocalisationByIdPath = '/v1/localisations/{idLocalisation}';

  /**
   * get.
   *
   * récupérer les données d'une localisation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLocalisationById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocalisationById$Response(
    params: GetLocalisationById$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<LocalisationDtoEnrichi>> {
    return getLocalisationById(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * récupérer les données d'une localisation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLocalisationById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocalisationById(params: GetLocalisationById$Params, context?: HttpContext): Observable<LocalisationDtoEnrichi> {
    return this.getLocalisationById$Response(params, context).pipe(
      map((r: StrictHttpResponse<LocalisationDtoEnrichi>): LocalisationDtoEnrichi => r.body)
    );
  }
}
